import {
  Component,
  Input,
  ChangeDetectorRef,
  ViewEncapsulation,
  ComponentRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  NbColorHelper,
  NbDialogRef,
  NbDialogService,
  NbThemeService,
} from '@nebular/theme';
import { Subject, Observable } from 'rxjs';

import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import { UsersService } from 'app/@core/backend/common/services/users.service';
import { User } from 'app/@core/interfaces/common/users';
import { Router } from '@angular/router';
import {
  FitnessItem,
  SetsBased,
  SettingDetailRow,
  WeightType,
  BlockType,
  FitnessBlock,
  FitnessItemHelper,
} from 'app/@core/interfaces/common/CalorieFriend/fitnessItem';
import { format } from 'support';
import { ExerciseEditComponent } from '../ExerciseEdit/exercise-edit.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ExerciseProgressData } from 'app/@core/interfaces/common/CalorieFriend/exercise-progress';
import { ExerciseLogData } from 'app/@core/interfaces/common/CalorieFriend/exerciseLog';
import {
  WorkoutDetail,
  WorkoutDetailStatus,
} from 'app/@core/interfaces/common/CalorieFriend/workout';
import { OverlayFitnessItemPresentationComponent } from './fitness-item-presentation-overlay.component';
import { FitnessItemPresentationComponentBase } from './fitness-item-presentation-base.component';
import { WorkoutService } from 'app/@core/backend/common/services/CalorieFriend/workout.service';

/**
 * Component for Meal Item presentation.
 * Inherits from the MealItemPresentationComponentBase component.
 */
@Component({
  selector: 'app-fitness-item-presentation',
  templateUrl: './fitness-item-presentation.component.html',
  styleUrls: [
    './fitness-item-presentation.component.scss',
    '../../global.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FitnessItemPresentationComponent
  extends FitnessItemPresentationComponentBase
  implements OnInit {



  constructor(
    private PresDialogService: NbDialogService,
    PresExerciseProgressService: ExerciseProgressData,
    private workoutService: WorkoutService,
  ) {
    super(PresDialogService, PresExerciseProgressService);
  }

  onClickImage(): void {
    if (this.IsViewOnly) return;


    if (this.IsPatientView) {
      // start exercise based on block and exercise id
      this.workoutService.startExcercise.next({
        blockId: this.fitnessBlock.id,
        excerciseId: this.Item.id,
        isWorkout: false,
      });
    } else {
      const ref: ComponentRef<ExerciseEditComponent> =
        this.PresDialogService.open(ExerciseEditComponent, {
          closeOnEsc: false,
          context: {
            InputItem: this.Item,
            PatientID: this.PatientID,
            PatientName: this.PatientName,
            IsPreferredUnitImperial: this.IsPreferredUnitImperial,
            fitnessBlock: this.fitnessBlock,
            ShowEditButtons: true,
            RemoveCallBack: this.onDeleteItem.bind(this),
            SaveCallBack: this.onSaveItem.bind(this),
          },
        }).componentRef;
    }
  }





  public getVideoUrl(source:string):string {
    return source + "#t=0.001"
  }

  onSaveItem() {
    if (this.Item && this.SaveCallBack) {
      this.SaveCallBack(this.Item);
    }
  }

  onDeleteItem() {
    if (this.Item && this.DeleteCallBack) {
      this.DeleteCallBack(this.Item);
    }
  }

  get ItemName() {
    const result = this.Item.name;
    return result;
  }


  formatTime(time) {
    if (time < 60) {
      return `${time} sec.`;
    } else {
      const min = Math.floor(time / 60);
      const sec = time % 60;
      if (sec > 0) {
        return `${min}m ${sec} s`;
      } else {
        return `${min} min`;
      }
    }
  }

  get ItemDescription() {



    let baseString = "<div class='item-line1'>{0} x {1} {2}";
    let result = "";

    let fitnessItem = this.Item;


    if (this.IsSuperSet && this.GetSupersetMaster != null) {
      fitnessItem = this.GetSupersetMaster;
    }


    if (fitnessItem.setsBased === SetsBased.RepsBased || fitnessItem.setsBased.toString() === '0' || fitnessItem.setsBased === SetsBased.Superset || fitnessItem.setsBased.toString() === '3') {
      result = format(baseString, this.BlockType === BlockType.Circuit ? 1 : fitnessItem.sets, this.Item.defaultRepsOrTime, 'Reps')
    }

    if (fitnessItem.setsBased === SetsBased.TimeBased || fitnessItem.setsBased.toString() === '1') {
      result = format(baseString, this.BlockType === BlockType.Circuit ? 1 : fitnessItem.sets, this.formatTime(this.Item.defaultRepsOrTime), '')
    }

    if (fitnessItem.setsBased === SetsBased.MaxRepBased || fitnessItem.setsBased.toString() === '2') {
      result = format(baseString, this.BlockType === BlockType.Circuit ? 1 : fitnessItem.sets, "Max Reps", '')
    }

    result += '</div>';

    if (
      fitnessItem.defaultRest &&
      fitnessItem.defaultRest > 0 &&
      this.BlockType.toString() !== BlockType.Circuit.toString()
    ) {
      if (fitnessItem.defaultRest < 60) {
        result += format(
          "<div class='item-line2'>{0} sec Rest</div>",
          fitnessItem.defaultRest
        );
      } else {
        result += format(
          "<div class='item-line2'>{0} min Rest</div>",
          Math.round(fitnessItem.defaultRest / 60)
        );
      }
    }

    return result;
  }
}
